import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import SideNavLayout from "../Sidenav/SideNavLayout";
import api from "../api/api";

const CATEGORY_LABELS = {
  Login: "Login",
  AddUser: "Add User",
};

const OtpLogs = () => {
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("ALL");
  const [logsData, setLogsData] = useState([]);

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await api.get("/v1/login-otp/logs");
      if (response?.status === 200) {
        setLogsData(response.data || []);
      } else {
        setLogsData([]);
      }
    } catch (error) {
      console.error("Failed to fetch OTP logs:", error);
      setLogsData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredLogs = logsData.filter((log) => {
    if (category !== "ALL" && log.category !== category) return false;
    if (searchText && !(log.phone || "").includes(searchText)) return false;
    return true;
  });

  return (
    <SideNavLayout>
      {loader && (
        <div className="fixed inset-0 bg-white/70 flex justify-center items-center z-[9999]">
          <CircularProgress size={60} />
        </div>
      )}

      <div className="p-6">
        <h1 className="text-2xl text-start font-semibold text-[#1d2951] mb-6">
          Web OTP
        </h1>

        {/* Filters */}
        <div className="flex flex-wrap gap-4 justify-between items-center p-3 border-b">
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="border border-gray-300 px-4 py-2 rounded-lg text-sm"
          >
            <option value="ALL">All Categories</option>
            <option value="Login">Login</option>
            <option value="AddUser">Add User</option>
          </select>

          <input
            type="text"
            placeholder="Search by mobile number"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="border border-gray-300 px-4 py-2 rounded-lg text-sm w-64"
          />
        </div>

        {/* Table Card */}
        <div className="bg-white rounded-xl shadow-sm border mt-4">
          <div className="max-h-[480px] overflow-y-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 text-center text-gray-600 uppercase text-xs sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3">S/N</th>
                  <th className="px-6 py-3">Mobile Number</th>
                  <th className="px-6 py-3">Category</th>
                  <th className="px-6 py-3">OTP</th>
                  <th className="px-6 py-3">Status</th>
                  <th className="px-6 py-3">Timestamp</th>
                </tr>
              </thead>

              <tbody>
                {filteredLogs.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="px-6 py-10 text-center text-gray-500">
                      No OTP logs found.
                    </td>
                  </tr>
                ) : (
                  filteredLogs.map((log, index) => (
                    <tr key={log.id} className="border-t text-center">
                      <td className="px-6 py-4">{index + 1}</td>
                      <td className="px-6 py-4">{log.phone}</td>
                      <td className="px-6 py-4">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${
                            log.category === "Login"
                              ? "bg-blue-50 text-blue-600"
                              : "bg-purple-50 text-purple-600"
                          }`}
                        >
                          {CATEGORY_LABELS[log.category] || log.category}
                        </span>
                      </td>
                      <td className="px-6 py-4 font-mono">{log.otp}</td>
                      <td className="px-6 py-4">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${
                            log.status === "A"
                              ? "bg-green-50 text-green-600"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          {log.status === "A" ? "Active" : "Used"}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-gray-600">
                        {log.created_on
                          ? new Date(log.created_on).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default OtpLogs;
